<template>
    <div class="popup" :class="{ active: popupShow }">
        <div class="popup__inner">
            <div class="popup__certification">
                <div class="popup__tit">
                    <h2>환자의 권리와 의무</h2>
                    <button type="button" class="popup__close" @click="popupBtn"><img src="@/assets/resource/icon/close.svg" alt=""></button>
                </div>
                <div class="popup__body">
                    <div class="info">
                        <ul>
                            <li>이화의료원은 인간 생명이 가지는 존엄과 가치를 인식하고 존중·보호하고 증진하기 위하여 다음과 같이 환자권리와 의무를 명시한다.</li>
                        </ul>
                    </div>
                    <div class="info">
                        <p class="popup__desc-point">
                           환자의 권리
                        </p>
                    </div>
                    <div class="info">
                        <p><b>1. 진료받을 권리</b></p>
                        <ul class="mt20">
                            <li>환자는 자신의 건강보호와 증진을 위하여 적절한 보건의료서비스를 받을 권리를 갖고, 성별·나이·종교·신분 및 경제적 사정 등을 이유로 건강에 관한 권리를 침해받지 아니하며, 의료인은 정당한 사유없이 진료를 거부하지 못한다.</li>
                        </ul>
                    </div>
                    <div class="info">
                        <p><b>2. 알 권리 및 자기결정권</b></p>
                        <ul class="mt20">
                            <li>환자는 담당 의사·간호사 등으로 부터 질병 상태, 치료 방법, 의학적 연구대상 여부, 장기이식 여부, 부작용 등 예상 결과 및 진료 비용에 관하여 충분한 설명을 듣고 자세히 물어볼 수 있으며, 이에 관한 동의 여부를 결정할 권리를 가진다.</li>
                        </ul>
                    </div>
                    <div class="info">
                        <p><b>3. 비밀을 보호받을 권리</b></p>
                        <ul class="mt20">
                            <li>환자는 진료와 관련된 신체상·건강상의 비밀과 사생활의 비밀을 침해받지 아니하며, 의료인과 의료기관은 환자의 동의를 받거나 범죄 수사 등 법률에서 정한 경우 외에는 비밀을 누설·발표하지 못한다.</li>
                        </ul>
                    </div>
                    <div class="info">
                        <p><b>4. 상담·조정을 신청할 권리</b></p>
                        <ul class="mt20">
                            <li>환자는 의료서비스 관련 분쟁이 발생한 경우, 한국의료분쟁조정중재원 등에 상담 및 조정 신청을 할 수 있다.</li>
                        </ul>
                    </div>
                    <div class="info">
                        <p><b>5. 안전한 의료환경에서 의료서비스를 제공받을 권리</b></p>
                        <ul class="mt20">
                            <li>환자는 환자의 진료정보가 보호되고 환자안전이 유지되는 의료기관에서 의료서비스를 제공받을 권리가 있다.</li>
                        </ul>
                    </div>
                    <div class="info">
                        <p class="popup__desc-point">
                           환자의 의무
                        </p>
                    </div>
                    <div class="info">
                        <p><b>1. 의료인에 대한 신뢰·존중 의무</b></p>
                        <ul class="mt20">
                            <li>환자는 자신의 건강 관련 정보를 의료인에게 정확히 알리고, 의료인의 치료 계획을 신뢰하고 존중하여야 한다.</li>
                        </ul>
                    </div>
                    <div class="info">
                        <p><b>2. 부정한 방법으로 진료를 받지 않을 의무</b></p>
                        <ul class="mt20">
                            <li>환자는 진료 전에 본인의 신분을 밝혀야 하고, 다른 사람의 명의로 진료를 받는 등 거짓이나 부정한 방법으로 진료를 받지 아니한다.</li>
                        </ul>
                    </div>
                    <div class="botton-wrap">
                        <a href="javascript:;" class="sub-button c-main" @click="popupBtn">닫기</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                popupShow: false
            }
        },
        components: {
        },
        mounted() {
        },
        methods: {
            popupBtn() {
                this.popupShow = !this.popupShow
            }
        },
    }
</script>